export const getPrimaryDataset = datasets => {
  return datasets.get('primary');
};
export const getPrimaryDataDataset = datasets => {
  return datasets.getIn(['primary', 'data']);
};
export const getPrimaryDataDatasetData = datasets => {
  return datasets === null || datasets === void 0 ? void 0 : datasets.getIn(['primary', 'data', 'data']);
};
export const getPrimaryDataDatasetPaginationSize = datasets => {
  return datasets === null || datasets === void 0 ? void 0 : datasets.getIn(['primary', 'data', 'paginationSize']);
};
export const getPrimaryDataDatasetPaginationTotalHitCountMaybe = datasets => {
  return datasets === null || datasets === void 0 ? void 0 : datasets.getIn(['primary', 'data', 'paginationTotalHitCountMaybe']);
};
export const getCompareDataset = datasets => {
  return datasets.get('compare') || undefined;
};
export const getCompareDataDataset = datasets => {
  return datasets.getIn(['compare', 'data']);
};
export const getDatasetInsightsMetricName = dataset => {
  const insightMeta = dataset.get('insightMeta');
  return insightMeta && insightMeta.get('metricName');
};
export const getDatasetInsightsBreakdownValue = dataset => {
  const insightMeta = dataset.get('insightMeta');
  return insightMeta && insightMeta.get('breakdownValue');
};
export const getDatasetInsightsType = dataset => {
  const insightOption = dataset.get('insightOption');
  return insightOption && insightOption.get('insightType');
};
export const getDatasetInsightsRangeName = dataset => {
  const insightMeta = dataset.get('insightMeta');
  return insightMeta && insightMeta.get('rangeName');
};